module Meevo.Plugins.ActivityLog {
    export class ActivityInfinityScroll implements angular.IDirective {
        restrict = 'A';
        scope = {
            scrollCallback: '&',
        };
        link = (scope: any, element: angular.IAugmentedJQuery) => {

            element.bind( 'scroll', ($event) => {
                let scrollOffset = $event.target.scrollHeight - $event.target.scrollTop;
                let clientOffset = $event.target.clientHeight + 150; // client view + 150px for fetch before very end of block

                if (clientOffset >= scrollOffset) {
                    scope.scrollCallback();
                }
            } );
        }

        constructor(
            protected $timeout: ng.ITimeoutService
        ) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new ActivityInfinityScroll( $timeout );
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }


    angular.module( 'meevo.plugins.activityLog' )
        .directive( 'activityInfinityScroll', ActivityInfinityScroll.factory() );
}